module.exports = {
	"title": "CSS Device Adaptation",
	"description": "A standard way to override the size of viewport in web page using the `@viewport` rule, standardizing and replacing Apple's own popular `<meta>` viewport implementation.",
	"spec": "http://www.w3.org/TR/css-device-adapt/",
	"status": "wd",
	"links": [
		{
			"url": "https://dev.opera.com/articles/view/an-introduction-to-meta-viewport-and-viewport/",
			"title": "Introduction to meta viewport and @viewport in Opera Mobile"
		},
		{
			"url": "http://msdn.microsoft.com/en-us/library/ie/hh708740(v=vs.85).aspx",
			"title": "Device adaptation in Internet Explorer 10"
		},
		{
			"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6777420-unprefix-and-support-all-viewport-properties",
			"title": "Microsoft Edge feature request on UserVoice"
		},
		{
			"url": "https://code.google.com/p/chromium/issues/detail?id=155477",
			"title": "Chrome tracking bug"
		},
		{
			"url": "https://bugs.webkit.org/show_bug.cgi?id=95959",
			"title": "WebKit tracking bug"
		},
		{
			"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=747754",
			"title": "Mozilla tracking bug"
		}
	],
	"bugs": [],
	"categories": [
		"CSS"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "a x #1",
			"11": "a x #1",
			"5.5": "n"
		},
		"edge": {
			"12": "a x #1",
			"13": "a x #1",
			"14": "a x #1"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n",
			"48": "n",
			"49": "n",
			"50": "n",
			"51": "n",
			"52": "n",
			"53": "n",
			"3.5": "n",
			"3.6": "n"
		},
		"chrome": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n d",
			"30": "n d",
			"31": "n d",
			"32": "n d",
			"33": "n d",
			"34": "n d",
			"35": "n d",
			"36": "n d",
			"37": "n d",
			"38": "n d",
			"39": "n d",
			"40": "n d",
			"41": "n d",
			"42": "n d",
			"43": "n d",
			"44": "n d",
			"45": "n d",
			"46": "n d",
			"47": "n d",
			"48": "n d",
			"49": "n d",
			"50": "n d",
			"51": "n d",
			"52": "n d",
			"53": "n d",
			"54": "n d",
			"55": "n d",
			"56": "n d",
			"57": "n d"
		},
		"safari": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"3.1": "n",
			"3.2": "n",
			"5.1": "n",
			"6.1": "n",
			"7.1": "n",
			"9.1": "n",
			"TP": "n"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n d",
			"41": "n d",
			"42": "n d",
			"43": "n d",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "n",
			"10": "n",
			"3.2": "n",
			"4.0-4.1": "n",
			"4.2-4.3": "n",
			"5.0-5.1": "n",
			"6.0-6.1": "n",
			"7.0-7.1": "n",
			"8.1-8.4": "n",
			"9.0-9.2": "n",
			"9.3": "n"
		},
		"op_mini": {
			"all": "a x #2"
		},
		"android": {
			"3": "n",
			"4": "n",
			"53": "n",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "n",
			"4.2-4.3": "n",
			"4.4": "n",
			"4.4.3-4.4.4": "n"
		},
		"bb": {
			"7": "n",
			"10": "n"
		},
		"op_mob": {
			"10": "n",
			"11": "a x #2",
			"12": "a x #2",
			"37": "n",
			"11.1": "a x #2",
			"11.5": "a x #2",
			"12.1": "a x #2"
		},
		"and_chr": {
			"53": "n"
		},
		"and_ff": {
			"49": "n"
		},
		"ie_mob": {
			"10": "a x #1",
			"11": "a x #1"
		},
		"and_uc": {
			"11": "n"
		},
		"samsung": {
			"4": "n"
		}
	},
	"notes": "",
	"notes_by_num": {
		"1": "IE only supports the 'width' and 'height' properties.",
		"2": "Opera Mobile and Opera Mini only support the 'orientation' property."
	},
	"usage_perc_y": 0,
	"usage_perc_a": 10.28,
	"ucprefix": false,
	"parent": "",
	"keywords": "viewport",
	"ie_id": "",
	"chrome_id": "4737164243894272",
	"firefox_id": "",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-deviceadaptation.json
 ** module id = 415
 ** module chunks = 0
 **/